'use strict';

var intersection = require('array-intersection');

module.exports = function () {

  var opts = this.opts;

  return opts.dateColumns.length && opts.filterByColumn && (typeof opts.filterable == 'boolean' && opts.filterable || intersection(opts.filterable, opts.dateColumns).length);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/has-date-filters.js
// module id = 247
// module chunks = 0